import Cookies from "universal-cookie";

import config from "../config";
import getCompleteApiUrl from "../getCompleteApiUrl";
import {OperatorEmergencyReservation} from "../../classes/OperatorEmergencyReservation";
import {ApiCallFailure} from "../../classes/exception/ApiCallFailure";

export default async function createOperatorEmergencyReservation(reservation: OperatorEmergencyReservation) {
    const cookies = new Cookies();

    if (cookies.get("accessToken") === undefined) {
        const error = new ApiCallFailure()
        error.connectionSuccessful = false
        error.errorType = "NO_ACCESS_TOKEN"

        throw error
    }

    var res: Response
    try {
        res = await fetch(getCompleteApiUrl(config, "/operators/emergencies"), {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${cookies.get("accessToken")}`
            },
            body: JSON.stringify({
                operatorId: reservation.operatorId,
                isAvailable: reservation.isAvailable,
                timeBegin: reservation.timeBegin.format(),
                timeEnd: reservation.timeEnd.format(),
            }),
        })
    } catch (error) {
        const apiFailure = new ApiCallFailure()
        apiFailure.connectionSuccessful = false

        throw apiFailure
    }

    if (res!.status === 201) {
        const responseObject = await res!.json()

        const responseReservation = new OperatorEmergencyReservation()
        responseReservation.parseObject(responseObject)

        return responseReservation
    }

    const callFailure = new ApiCallFailure()
    callFailure.connectionSuccessful = true
    callFailure.responseCode = res!.status
    callFailure.errorType = "REQUEST_REJECTED"

    throw callFailure
}